var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36 3H2.16C2.072 3 2 3.075 2 3.16667V16.8333C2 16.925 2.072 17 2.16 17H3.36C3.448 17 3.52 16.925 3.52 16.8333V3.16667C3.52 3.075 3.448 3 3.36 3ZM17.84 3H16.64C16.552 3 16.48 3.075 16.48 3.16667V16.8333C16.48 16.925 16.552 17 16.64 17H17.84C17.928 17 18 16.925 18 16.8333V3.16667C18 3.075 17.928 3 17.84 3ZM15.466 9.83958L12.914 7.74167C12.8926 7.72417 12.867 7.71329 12.84 7.71028C12.813 7.70727 12.7857 7.71225 12.7613 7.72464C12.7368 7.73704 12.7163 7.75635 12.7019 7.78036C12.6875 7.80437 12.6799 7.83212 12.68 7.86042V9.25H7.32V7.94167C7.32 7.81667 7.18 7.74583 7.086 7.82292L4.534 9.92292C4.51673 9.93682 4.50275 9.95465 4.49313 9.97506C4.48351 9.99546 4.47851 10.0179 4.47851 10.0406C4.47851 10.0634 4.48351 10.0858 4.49313 10.1062C4.50275 10.1266 4.51673 10.1444 4.534 10.1583L7.084 12.2583C7.178 12.3354 7.318 12.2667 7.318 12.1396V10.75H12.678V12.0583C12.678 12.1833 12.818 12.2542 12.912 12.1771L15.462 10.0771C15.538 10.0167 15.538 9.9 15.466 9.83958Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistanceIcon);
export default __webpack_public_path__ + "static/media/distance-icon.fd8d9739e25237c71db941655deadcd9.svg";
export { ForwardRef as ReactComponent };